import React, { useState,useEffect } from 'react';
import { Accordion } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';

function AvisArbitrage(props) {
    const [confirmation,setConfirmation] = useState(false);
    const [status, setStatus] = useState()
    const [note, setNote] = useState(0);
    const [commentaire, setCommentaire] = useState()
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;


    useEffect(() => {
        if (props.avis) {
            const item = props.avis.find(item => item.id_candidature === props.status.id_candidature);
            if (item) {
                setNote(item.note);
                setCommentaire(item.commentaireCoach);
            }
        }
    }, [props.avis, props.status.id_candidature]);


    
    const handleRatingChange = (e) => {
      setNote(parseInt(e.target.value));
    };


    const handleSubmitModif = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
        
        try {
          await axios.patch(`${apiUrl}/arbitrage/candidature/avis/modifier`, {
            status : status,
            note : note,
            commentaire : commentaire,
            idCandidature : props.status.id_candidature
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          console.log(error)
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };
      const handleSubmitAjout = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
        
        try {
          await axios.post(`${apiUrl}/arbitrage/candidature/avis/ajouter`, {
            status : status,
            note : note,
            commentaire : commentaire,
            idCandidature : props.status.id_candidature
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          console.log(error)
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };

      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      }
      if(error){
          return (
              <>
              <div id="alert-message" className="alert4" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div>
            </>  
          )
      }

  return (
    <>
        {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>{status === 'modifier' ? ('Confirmer votre modification'):('Confirmer votre avis')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {status === 'modifier' ? ('Voulez-vous vraiment modifier votre avis ?'):(`Voulez-vous vraiment ajouter votre avis ?`)}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => status === 'modifier' ? handleSubmitModif(e) : handleSubmitAjout(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    <Accordion defaultActiveKey="0">
    {props.status && props.status.status === "accepter" && (
                    <> 
                        {props.avis && props.avis.filter(items => items.id_candidature === props.status.id_candidature).length !== 0 ? ( 
                            props.avis.filter(items => items.id_candidature === props.status.id_candidature).map((Item, index) => (                
                                <div key={index} className="rating-container">
                                    <div className="rating-container">
                                        <Form.Label>Commentaire de l'abitre</Form.Label>
                                        <Form.Control as="textarea" value={Item.commentaireArbitre !== null ? (Item.commentaireArbitre):('')} disabled rows={3} />
                                        <br/>
                                        <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                            Modifier votre note sur la prestation de <a href={`/coach/equipe/arbitre/${props.status.id_arbitre}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{props.status.nom} {props.status.prenom}</span></a>
                                        </div>  
                                        <div className="rating-criteria">
                                            <div className="rating-stars criteria1">
                                                <input type="radio" id={`star5_${Item.id_candidature}`} name={`rating_${Item.id_candidature}`} checked={note === 5} value="5" onChange={handleRatingChange} />
                                                <label htmlFor={`star5_${Item.id_candidature}`}></label>
                                                <input type="radio" id={`star4_${Item.id_candidature}`} name={`rating_${Item.id_candidature}`} checked={note === 4} value="4" onChange={handleRatingChange} />
                                                <label htmlFor={`star4_${Item.id_candidature}`}></label>
                                                <input type="radio" id={`star3_${Item.id_candidature}`} name={`rating_${Item.id_candidature}`} checked={note === 3} value="3" onChange={handleRatingChange} />
                                                <label htmlFor={`star3_${Item.id_candidature}`}></label>
                                                <input type="radio" id={`star2_${Item.id_candidature}`} name={`rating_${Item.id_candidature}`} checked={note === 2} value="2" onChange={handleRatingChange} />
                                                <label htmlFor={`star2_${Item.id_candidature}`}></label>
                                                <input type="radio" id={`star1_${Item.id_candidature}`} name={`rating_${Item.id_candidature}`} checked={note === 1} value="1" onChange={handleRatingChange} />
                                                <label htmlFor={`star1_${Item.id_candidature}`}></label>
                                            </div>
                                        </div>
                                        </div>
                                        <Form.Label>Modifier votre commentaire</Form.Label>
                                        <Form.Control as="textarea" value={commentaire !== null ? (commentaire):('')}  rows={3} onChange={(e) => setCommentaire(e.target.value)} />
                                        <br/>
                                        <div style={{textAlign:"right"}}>
                                            <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus('modifier')}} >Modifier votre avis</Button>
                                        </div>   
                                    </div> 
                                            ))
                                    ) : (
                                        <div className="rating-container">
                                            <div className="rating-container">
                                                    <br/>
                                                <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                                    Ajouter une note sur la prestation de <a href={`/coach/equipe/arbitre/${props.status.id_arbitre}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{props.status.nom} {props.status.prenom}</span></a>
                                                </div>  
                                                <div className="rating-criteria">
                                                    <div className="rating-stars criteria1">
                                                        <input type="radio" id={`star5_${props.status.id_candidature}`} name={`rating_${props.status.id_candidature}`} value="5" onChange={handleRatingChange} />
                                                        <label htmlFor={`star5_${props.status.id_candidature}`}></label>
                                                        <input type="radio" id={`star4_${props.status.id_candidature}`} name={`rating_${props.status.id_candidature}`} value="4" onChange={handleRatingChange} />
                                                        <label htmlFor={`star4_${props.status.id_candidature}`}></label>
                                                        <input type="radio" id={`star3_${props.status.id_candidature}`} name={`rating_${props.status.id_candidature}`} value="3" onChange={handleRatingChange} />
                                                        <label htmlFor={`star3_${props.status.id_candidature}`}></label>
                                                        <input type="radio" id={`star2_${props.status.id_candidature}`} name={`rating_${props.status.id_candidature}`} value="2" onChange={handleRatingChange} />
                                                        <label htmlFor={`star2_${props.status.id_candidature}`}></label>
                                                        <input type="radio" id={`star1_${props.status.id_candidature}`} name={`rating_${props.status.id_candidature}`} value="1" onChange={handleRatingChange} />
                                                        <label htmlFor={`star1_${props.status.id_candidature}`}></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <Form.Label>Ajouter un commentaire</Form.Label>
                                            <Form.Control as="textarea"  rows={3} onChange={(e) => setCommentaire(e.target.value)} />
                                            <br/>
                                            <div style={{textAlign:"right"}}>
                                                <Button variant="primary" style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  onClick={() => {setConfirmation(true);setStatus('ajouter')}} >Ajouter un avis</Button>
                                            </div>   
                                        </div> 
                                    )}
                            
                </>             
            )}

    </Accordion><br/>

    </>
  );
}

export default AvisArbitrage;